<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.promos')" :title="$t('help.promos_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="promosTable"
        url="/admin/promos"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true"
        class="white-container">

        <template slot="beforeFilter">
          <b-row>
            <b-col>
              <router-link to="promos/create">
                <b-button
                  class="px-4" >
                  {{$t('promo.add')}}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/promos/edit/${props.row.id}`, params: props.row}" target="_blank">
            {{ props.row.id }}
          </router-link>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>

        <template slot="discount" slot-scope="props">
          <cents-to-bills v-if="props.row.discount_type === 'amount'"
                          :row="props.row" column="discount" :currency="true"/>
          <span v-else>{{props.row.discount}}%</span>
        </template>

        <template slot="count_uses" slot-scope="props">
          <router-link :to="{path: '/promos/users/' + props.row.id, props: {promo: 'test'}}"
                       v-if="props.row.count_uses > 0">{{props.row.count_uses}}</router-link>
          <span v-else>{{props.row.count_uses}}</span>
        </template>

        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/promos/${props.row.id}`"
            :route="{path: `/promos/edit/${props.row.id}`, params: {id: props.row.id}}"
            @deleteItems="refreshTable('appTable')"/>
        </template>

      </v-server-table>
    </div>
  </div>
</template>
<script>
  import axios from "@/utils/axios";
  import promoFilters from './promoFilters.js';
  import filters from '@/components/global/filters';
  import i18n from "@/utils/i18n";
  import {Event} from 'vue-tables-2';

  export default {
    middleware: "auth",
    name: "Invites",
    components: {filters},
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ["id", "title", "discount", "code", "count_uses", "actions"],
        filters: promoFilters,
        options: {
          skin: [],
          headings: {
            id: "#",
            title: i18n.t('form.title'),
            discount: i18n.t('form.discount'),
            code: i18n.t('form.code'),
            count_uses: i18n.t('form.uses'),
            actions: i18n.t('button.edit'),
          },
          sortable: [],
          filterByColumn: false,
          columnsDropdown: false,
          customFilters: ["custom"],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: (data) => {
            localStorage.setItem('perPage', data.limit);
            return axios.get("/admin/promos", {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch("error", e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.promosTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.promosTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.promosTable.loaded');
    }
  }
</script>
